import * as Input from "../../components/Form/Input";
import { Button } from "../../components/Button";
import { useState } from "react";

export function CreateDriver() {
  const [name, setName] = useState("");
  const [telefone, setTelefone] = useState("");
  const [codEmpresa, setCodEmpresa] = useState("");
  const [turno, setTurno] = useState("");

  return (
    <>
      <div className="mt-6 flex flex-col">
        <div className="flex flex-col justify-between gap-4 lg:flex-row lg:items-center">
          <div className="flex flex-col gap-1">
            <h2 className="text-lg font-medium text-zinc-900 dark:text-white">
              Informações do motorista
            </h2>
            <span className="text-sm text-zinc-500 dark:text-zinc-400">
              Preencha os dados do motorista.
            </span>
          </div>

          {/* <div className="flex items-center gap-2">
            <Button type="button" variant="outline">
              Cancelar
            </Button>
            <Button type="submit" form="company" variant="primary">
              Salvar
            </Button>
          </div> */}
        </div>
      </div>

      <form
        id="company"
        className="mt-6 flex w-full flex-col gap-5 divide-y divide-zinc-200 dark:divide-zinc-800"
      >
        <div className="grid gap-3 lg:grid-cols-form">
          <label
            htmlFor="nome"
            className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
          >
            Nome
          </label>
          <div className="grid gap-6 lg:grid-cols-2">
            <Input.Root>
              <Input.Control
                name="nome"
                placeholder="Nome"
                id="nome"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Input.Root>
          </div>
        </div>
        <div className="grid gap-3 lg:grid-cols-form pt-5">
          <label
            htmlFor="telefone"
            className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
          >
            Telefone
          </label>
          <div className="grid gap-6 lg:grid-cols-2">
            <Input.Root>
              <Input.Control
                name="telefone"
                placeholder="Telefone"
                id="telefone"
                type="text"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value)}
              />
            </Input.Root>
          </div>
        </div>
        <div className="grid gap-3 lg:grid-cols-form pt-5">
          <label
            htmlFor="company"
            className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
          >
            Empresa pertencente
          </label>
          <div className="grid gap-6 lg:grid-cols-2">
            <Input.Root>
              <Input.Control
                name="company"
                placeholder="Nome da empresa"
                id="company"
                type="text"
                value={codEmpresa}
                onChange={(e) => setCodEmpresa(e.target.value)}
              />
            </Input.Root>
          </div>
        </div>
        <div className="grid gap-3 lg:grid-cols-form pt-5">
          <label
            htmlFor="turn"
            className="text-sm font-medium text-zinc-700 dark:text-zinc-100"
          >
            Turnos
          </label>
          <div className="grid gap-6 lg:grid-cols-2">
            <Input.Root>
              <Input.Control
                name="turn"
                placeholder="Informe os turnos"
                id="turn"
                type="text"
                value={turno}
                onChange={(e) => setTurno(e.target.value)}
              />
            </Input.Root>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 pt-5">
          <Button type="button" variant="outline">
            Cancelar
          </Button>
          <Button type="submit" form="company" variant="primary">
            Salvar
          </Button>
        </div>
      </form>
    </>
  );
}
